declare namespace $ {

	type $shm_button_copy__blobs_shm_showcase_demo_button_copy_1 = $mol_type_enforce<
		ReturnType< $shm_showcase_demo_button_copy['copy_blobs'] >
		,
		ReturnType< $shm_button_copy['blobs'] >
	>
	export class $shm_showcase_demo_button_copy extends $mol_view {
		copy_blobs( ): readonly(any)[]
		Copy( ): $shm_button_copy
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=copy.view.tree.d.ts.map